// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueSlideBar from 'vue-slide-bar'
import VueSweetalert2 from 'vue-sweetalert2'
import VueTextareaAutosize from 'vue-textarea-autosize'
import axios from 'axios'
import VueAxios from 'vue-axios'
import firebase from '@/firebase'
import ToggleButton from 'vue-js-toggle-button'

import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";


import store from './store'

import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule'

import Directives from "./directives";
Object.keys(Directives).forEach(name => Vue.directive(name, Directives[name]));

//Bus Especies
export const busEspecies = new Vue()
//Bus Productos
export const busProductos = new Vue()
//Bus servicios
export const busServicios = new Vue()
//Bus Estudios
export const busEstudios = new Vue()
//Bus Casos
export const busCasos = new Vue()
//Bus saldo
export const busSaldo = new Vue()

import './filters'

const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "G-TK0LYEEPYL" }
});

Vue.use(BootstrapVue)
Vue.use(VueSweetalert2, options)
Vue.use(SchedulePlugin)
Vue.use(VueTextareaAutosize)
Vue.use(VueAxios, axios)
Vue.use(ToggleButton)

// Validator
Vue.use(
  VeeValidate,
  { fieldsBagName: "formFields" } /*, {events: "change|blur|keyup",}*/
);
// Indicar uso de idioma español
Validator.localize("es", es);


Vue.component('vue-slide-bar', VueSlideBar)
Vue.config.productionTip = false

// Firebase Messagin  :: Notificaciones Web

if (firebase.messaging.isSupported()) {
  Vue.prototype.$messaging = firebase.messaging()
  Vue.prototype.$messaging.usePublicVapidKey(
    'BAKKruvNzT35R4C5OOyKrKgzS6HQq8Y9BH97xnY73FxorHn2DjkrRDWhdJxt7nSbyOe0H6fgX8ghr7rUAfcSGmk'
  )

  navigator.serviceWorker
    .register('/static/firebase-messaging-sw.js')
    .then(registration => {
      Vue.prototype.$messaging.useServiceWorker(registration)
    })
    .catch(err => {
      console.log(err)
    })
}

Vue.mixin({
  methods: {
    async mostrarAlerta(e){
     return await this.$swal.fire("Bien hecho!","Los datos han sido guardados correctamente","success")
    },
    mostrarAlertaError(e){
      this.$swal.fire("Upps!","Ocurrió un error inesperado","error")
      console.error("Error ", e)
    },
    mostrarCamposRequeridos(){
      return this.$swal.fire("Upps","Algunos campos son requeridos","warning");
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js